import {
  WebhookListItem,
  WebhookSubjectTypeDropdown,
  WebhookSubscription,
  WebhookType
} from 'app/webhooks/model/webhooks.model';
import {
  DELETE_WEBHOOK_SUCCESS,
  FILTER_WEBHOOK_LIST,
  GET_ALL_WEBHOOKS_SUCCESS,
  GET_MSISDNS_FOR_WEBHOOKS_SUCCESS,
  GET_SINGLE_WEBHOOK_SUCCESS,
  GET_WEBHOOK_TYPES_SUCCESS,
  WebhooksAction
} from 'app/webhooks/webhooks.actions';
import { createSelector } from 'reselect';
import { Msisdn } from 'app/shared/msisdn/msisdns';

export interface WebhooksState {
  list: WebhookListItem[];
  listFilter: WebhookSubjectTypeDropdown;
  showType: 'ALL' | 'GLOBAL' | 'PER_NUMBER';
  types: WebhookType[];
  msisdnsForWebhooks: Msisdn[];
  currentWebhook?: WebhookSubscription;
}

export const initialState: WebhooksState = {
  list: [],
  showType: 'ALL',
  types: [],
  msisdnsForWebhooks: [],
  listFilter: 'ALL'
};

export function webhooksReducer(state: WebhooksState = initialState, action: WebhooksAction): WebhooksState {
  switch (action.type) {
    case GET_ALL_WEBHOOKS_SUCCESS:
      return { ...state, list: action.payload, currentWebhook: null, listFilter: 'ALL' };
    case GET_WEBHOOK_TYPES_SUCCESS:
      return { ...state, types: action.payload };
    case GET_MSISDNS_FOR_WEBHOOKS_SUCCESS:
      return { ...state, msisdnsForWebhooks: action.payload };
    case GET_SINGLE_WEBHOOK_SUCCESS:
      return { ...state, currentWebhook: action.payload };
    case DELETE_WEBHOOK_SUCCESS: {
      return { ...state, list: state.list.filter(webhook => webhook.id !== action.payload) };
    }
    case FILTER_WEBHOOK_LIST:
      return { ...state, listFilter: action.payload };
    default:
      return state;
  }
}

const getList = (state: WebhooksState) => state.list;
const getFilteredList = (state: WebhooksState) =>
  state.listFilter === 'ALL' ? state.list : state.list.filter(webhook => webhook.subjectType === state.listFilter);
const getTypes = (state: WebhooksState) => state.types;
const getMsisdnsForWebhooks = (state: WebhooksState) => state.msisdnsForWebhooks;
const getCurrent = (state: WebhooksState) => state.currentWebhook;

export const getMainWebhooksSelector = (state): WebhooksState => state.webhooks;
export const getWebhookListSelector = createSelector(getMainWebhooksSelector, getList);
export const getWebhookFilteredListSelector = createSelector(getMainWebhooksSelector, getFilteredList);
export const getWebhookTypesSelector = createSelector(getMainWebhooksSelector, getTypes);
export const getMsisdnsForWebhooksSelector = createSelector(getMainWebhooksSelector, getMsisdnsForWebhooks);
export const getCurrentWebhookSelector = createSelector(getMainWebhooksSelector, getCurrent);
